export default "__VITE_ASSET__DEijgtBl__ 720w";